"use strict";

/* -------------------------------------------------------------------------

	PUNITED.common

	サイト内で共通のスクリプトを定義
	※jQuery必須
	Potential United inc.

------------------------------------------------------------------------- */
// グローバル名前空間定義
var PUNITED;
if (!PUNITED) PUNITED = {};
if (!PUNITED.common) PUNITED.common = {};

(function () {
  // グローバル名前空間オブジェクトをローカルオブジェクトに置き換え
  var ns = PUNITED.common;
  ns.mediaQuery = matchMedia('(max-width: 679px)');
  ns.body = document.querySelector('body');
  ns.header = document.querySelector('.site_header');
  ns.classes = {
    open: '--open',
    spOpen: '--sp_open',
    noScroll: '--no_scroll'
  };
  /* -----------------------------------------------------
  	IEの場合にメッセージを表示
  ----------------------------------------------------- */

  var userAgent = window.navigator.userAgent.toLowerCase();

  if (userAgent.indexOf('trident') != -1 || userAgent.indexOf('msie') != -1) {
    $("html").addClass("regacy_ie");
  }

  ns.calcScrollbarWidthOffset = function () {
    calc();
    window.addEventListener('resize', function () {
      calc();
    });

    function calc() {
      var offset = Math.max(0, window.innerWidth - ns.body.clientWidth);
      ns.body.style.setProperty('--scrollbar--width', "".concat(offset, "px"));
    }
  };

  ns.handleHeaderNavToggle = function () {
    var toggle = document.querySelector('.site_header_toggle_btn');
    toggle.addEventListener('click', function () {
      var open = ns.header.classList.toggle(ns.classes.open);
      ns.body.classList.toggle(ns.classes.noScroll, open);
    });
  };

  ns.handleSpNav = function () {
    var groups = document.querySelectorAll(".site_footer_nav_group.--has_children");
    init(ns.mediaQuery.matches);
    ns.mediaQuery.addEventListener("change", handleMediaChange);

    function handleMediaChange(e) {
      init(e.matches);
    }

    function init(matches) {
      groups.forEach(function (group) {
        var toggle = group.querySelector(".site_footer_nav_group__head > .site_footer_nav_link");
        toggle.removeEventListener("click", handleToggleClick);

        if (matches) {
          toggle.addEventListener("click", handleToggleClick);
        }
      });
    }

    function handleToggleClick(e) {
      e.preventDefault();
      var container = e.currentTarget.closest('.site_footer_nav_group');
      container.classList.toggle(ns.classes.spOpen);
    }
  };

  ns.handleFloatingEntryMenu = function () {
    var footer = document.querySelector('.site_footer');
    var floatingMenu = document.querySelector('.entry_floating_menu');
    var bannerMenu = document.querySelector('#footer_entry_banner_menu');

    if (!floatingMenu || !bannerMenu) {
      return;
    }

    var hiddenClass = '--hidden';
    ScrollTrigger.create({
      trigger: bannerMenu,
      endTrigger: footer,
      start: 'top bottom',
      end: 'bottom top',
      onToggle: function onToggle(self) {
        return floatingMenu.classList.toggle(hiddenClass, self.isActive);
      }
    });
  };

  ns.handleFloatingShapesAnimation = function () {
    var shapes = document.querySelectorAll('.upper_floating_shape.animation_fade_in, .floating_shape.animation_fade_in, .lower_floating_shape.animation_fade_in');
    shapes.forEach(function (shape) {
      ScrollTrigger.create({
        trigger: shape,
        start: 'top 75%',
        end: '+=1',
        toggleClass: '--played',
        once: true
      });
    });
  };

  ns.handleFooterAnimation = function () {
    if (!ns.body.classList.contains('has_animation')) {
      return;
    }

    var banner = document.querySelector('#footer_entry_banner_menu');
    var footer = document.querySelector('.site_footer');
    ScrollTrigger.create({
      trigger: banner,
      start: 'top 75%',
      end: '+=1',
      toggleClass: {
        targets: [banner, footer],
        className: '--played'
      },
      once: true
    });
  };
})();

$(function () {
  PUNITED.common.calcScrollbarWidthOffset();
  PUNITED.common.handleHeaderNavToggle();
  PUNITED.common.handleSpNav();
  PUNITED.common.handleFloatingEntryMenu();
  PUNITED.common.handleFloatingShapesAnimation();
  PUNITED.common.handleFooterAnimation();
});